export const getMimeTypeFromExtension = (fileName: string): string => {
  const ext = fileName.split(".").pop()?.toLowerCase() || "";

  const mime: { [key: string]: string } = {
    pdf: "application/pdf",
    doc: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.ms-powerpoint",
    txt: "text/plain",
    csv: "text/csv",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    svg: "image/svg+xml",
  };

  return mime[ext] || "application/octet-stream";
};
